<template>
    <div class="card mb-25 border-0 bg-white add-user-card">
        <div class="card-header">
            <h3 class="text-black fw-semibold">Enregistrement d'un magasin</h3>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
            <Form ref="magasinForm" @submit="addMagasin" :validation-schema="magasinSchema">
                <!-- <div class="col-md-3">
                    <br />
                    <div class="form-check mt-3 mb-15 mb-sm-20 mb-md-25">
                        <label for="estActif" class="form-check-label fw-medium position-relative top-1">
                            Est Principal ?
                        </label>
                        <input id="estPrincipal" name="estPrincipal" v-model="estPrincipal" :value="estPrincipal"
                            type="checkbox" class="form-check-input shadow-none" />
                        <ErrorMessage name="estPrincipal" class="text-danger" />
                    </div>
                </div> -->
                <div class="row mb-10">
                    <div class="col-md-3 mb-3">
                        <div class="form-group ">
                            <label class="d-block text-black fw-semibold mb-10">
                                Code du magasin <span class="text-danger">*</span>
                            </label>
                            <Field name="code" type="text" v-model="code"
                                class="form-control shadow-none fs-md-15 text-black"
                                placeholder="Entrer le code du magasin" />
                            <ErrorMessage name="code" class="text-danger" />
                        </div>
                    </div>
                    <div class="col-md-4 mb-3">
                        <div class="form-group ">
                            <label class="d-block text-black fw-semibold mb-10">
                                Nom du magasin <span class="text-danger">*</span>
                            </label>
                            <Field name="nomMagasin" type="text" class="form-control shadow-none fs-md-15 text-black"
                                placeholder="Entrer le nom magasin" />
                            <ErrorMessage name="nomMagasin" class="text-danger" />
                        </div>
                    </div>
                    <div class="col-md-5  mb-3">
                        <div class="form-group">
                            <label class="d-block text-black fw-semibold mb-10">
                                Magasinier <span class="text-danger">*</span>
                            </label>
                            <Field name="user" v-slot="{ field }">
                                <Multiselect :options="personnelOptions" :searchable="true" track-by="label"
                                    label="label" v-model="field.value" v-bind="field"
                                    placeholder="Sélectionner le magasinier" />
                            </Field>
                            <ErrorMessage name="user" class="text-danger" />
                        </div>
                    </div>
                    <div class="col-md-12 mb-3">
                        <div class="form-group">
                            <label class="d-block text-black fw-semibold mb-10">
                                Adresse du magasin <span class="text-danger">*</span>
                            </label>
                            <Field name="adresse" type="text" class="form-control shadow-none fs-md-15 text-black"
                                placeholder="Entrer l'adresse" />
                            <ErrorMessage name="adresse" class="text-danger" />
                        </div>
                    </div>
                </div>
                <button ref="submitButton" class="btn btn-primary me-5" type="submit">
                        Ajouter le magasin
                    </button>
                <button class="btn btn-danger" type="button" @click="router.push({ name: 'ListeMagasin' })">
                    Annuler
                </button>
            </Form>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as Yup from 'yup';
import ApiService from '@/services/ApiService';
import { error, success } from '@/utils/utils';
import { useRouter } from 'vue-router';
import Multiselect from '@vueform/multiselect/src/Multiselect';
import axios from 'axios';
import { Magasin } from '@/models/Magasin';

export default defineComponent({
    name: "AddMagasin",
    components: {
        Form,
        Field,
        ErrorMessage,
        Multiselect
    },

    setup: () => {
        const magasinSchema = Yup.object().shape({
            nomMagasin: Yup.string().required('Le nom du magasin est obligatoire'),
            code: Yup.string().required('Le code du magasin est obligatoire'),
            user: Yup.string().required('Le magasinier est obligatoire'),
            adresse: Yup.string().required('L\'adresse est obligatoire'),
        });

        const estPrincipal = ref(false);
        const personnelOptions = ref([]);
        const magasinForm = ref<Magasin | null>(null);
        const valuess = ref();
        const submitButton = ref<HTMLButtonElement | null>(null);
        const currentDateTime = ref(getCurrentDateTime());
        const code = ref('');

        const isDis = ref(true);
        const router = useRouter();
        const isDisable = ref(true);
        function getCurrentDateTime() {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            return `${year}-${month}-${day}T${hours}:${minutes}`;
        }


        const addMagasin = async (values: any, magasinForm) => {
            if (submitButton.value) {
                // eslint-disable-next-line
                submitButton.value.disabled = true;
            }
            values = values as Magasin;
            console.log("VVVVVVVVVVVVVVV ===> ", values);
            ApiService.post("/magasins", values)
                .then(({ data }) => {
                    console.log("DDDDDDDDDDD ===> ", data);
                    if (data.code == 201) {
                        success(data.message);
                        magasinForm.resetForm();
                        router.push({ name: 'ListeMagasin' });
                    }
                })
                .catch(({ response }) => {
                    submitButton.value!.disabled = false;
                    error(response.data.message);
                });
        };

        const fetchMagasin = async () => {
            try {
                const response = await axios.get('all/users');
                const userData = response.data.data;
                console.log("TTTTTTTTTTtt ===> ", userData);
                personnelOptions.value = userData.map((user) => ({
                    value: user.id,
                    label: `${user.nom} ${user.prenom}`,
                }));
            } catch (error) {
                console.log("RRYRYFJGHB ==> ", error);
            }
        };

        onMounted(async () => {
            fetchMagasin();
            currentDateTime.value = getCurrentDateTime();
        });


        return {
            isDis,
            isDisable,
            submitButton,
            currentDateTime,
            getCurrentDateTime,
            valuess,
            addMagasin,
            magasinSchema,
            estPrincipal,
            personnelOptions,
            code,
            router
        };
    },
});
</script>


<style scoped></style>